import {
  TrustPilotApiResponseSchema,
  type TrustpilotApiResponse,
} from '@athena-lib/TrustPilotProductReviewList/types';
import type { TrustPilotReviewsParams } from '../../routes/api/trustpilot/+server';
import { get } from '$lib/http';

export const fetchTrustpilotReviews = async (
  params: TrustPilotReviewsParams,
): Promise<TrustpilotApiResponse> => {
  const asQueryParams = Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  return get(`/api/trustpilot?${asQueryParams}`, TrustPilotApiResponseSchema);
};
